import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'

const Note = styled.div`
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
    text-align: center;
    color: ${({ theme }) => theme.font.label};
`

/**
 * Shown under a searched list when the server returned only the best matches
 * (40.02 §5.2): a search answer is one ranked page with no "load more", so
 * without this a broad search looks complete when it isn't.
 */
const SearchLimitNote = ({ result }) => {
    const { m } = useTranslation()
    const meta = result?.data?.pages?.at(-1)?.meta
    if (!meta?.searchMode || !meta.hasMore) return null

    return (
        <Note data-testid='list.search.limited'>
            {m('all.list.search.limited', [meta.size])}
        </Note>
    )
}

export default SearchLimitNote
